// extracted by mini-css-extract-plugin
module.exports = {"button":"ShowMoreText_button__32raF"};